import Rails from "@rails/ujs"
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["modal","image"];


  connect() {
  }

  openModal(event) {
    const url = event.params.url;
    if (!url) return;
    this.imageTarget.src = url;
    this.modalTarget.setAttribute("style", "display: block;")
  }

  closeModal() {
    this.imageTarget.src = "";
    this.modalTarget.setAttribute("style", "display: none;")
  }

  changeLanguage(event){
    const el = event.currentTarget;
    const locale = el.value;

    const row = event.target.closest('tr');
    const link = row?.querySelector('a.qr_link');
    if (link) {
      const u = new URL(link.getAttribute('href'), window.location.origin);
      u.searchParams.set('locale', locale);
      link.href = u.toString();
      link.textContent = u.toString();
    }

    const showButton = row?.querySelector('button.qr_code');
    if (showButton) {
      const attr = 'data-admin--stay-cares--index-url-param';
      const raw = showButton.getAttribute(attr) || '';
      const modalUrl = new URL(raw, window.location.origin);
      modalUrl.searchParams.set('locale', locale);
      showButton.setAttribute(attr, modalUrl.toString());
    }

    const downloadLink = row?.querySelector('a.download');
    if (downloadLink) {
      const u = new URL(downloadLink.getAttribute('href'), window.location.origin);
      u.searchParams.set('locale', locale);
      downloadLink.href = u.toString();
    }
  }
}
